import HeadData from 'components/Common/HeadData'
import React from 'react'

function CruiseShipsHeadData(props: { shipName: string }) {
  const { shipName } = props
  const currentYear = new Date().getFullYear()
  const title = `${shipName} | Best Deals ${currentYear}/${currentYear + 1}/${currentYear + 2}`
  const description = `Set sail on ${shipName} with exclusive deals from Luxury Escapes. Reserve your stateroom before it sells out.`

  return <HeadData title={title} description={description} />
}

export default CruiseShipsHeadData
